export default "__VITE_ASSET__D1al3XOo__"